import { ResetPasswordUsingToken } from 'supertokens-auth-react/recipe/emailpassword/prebuiltui';

/**
 * Forgot Password Page
 *
 * Uses SuperTokens pre-built UI for password reset flow.
 */
export function ForgotPasswordPage() {
  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <h1>Wandool</h1>
          <p>Reset your password</p>
        </div>
        <ResetPasswordUsingToken />
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
